import { render, staticRenderFns } from "./FireSimulation.vue?vue&type=template&id=6ec09db0&scoped=true&"
import script from "./FireSimulation.vue?vue&type=script&lang=js&"
export * from "./FireSimulation.vue?vue&type=script&lang=js&"
import style0 from "./FireSimulation.vue?vue&type=style&index=0&id=6ec09db0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec09db0",
  null
  
)

export default component.exports